import { Language } from './base';

const pdash = import('../translations/pdash/zu-ZU.json');
const webActivities = import('../translations/web-activities/zu-ZU.json');
const rdashTranslatables = import('../translations/rdash-translatables/zu-ZU.json');

export default new Language({
    code: 'zu-ZU',
    locale: 'zu',
    localName: 'IsiZulu',
    englishName: 'Zulu',
    territory: 'ZU',
    notLoadedNamespaces: { pdash, webActivities, rdashTranslatables },
});
